export const cuilToDni = (cuil: string) : string => {
    return (cuil?.length === 11) ? parseInt(cuil.substring(2, 10), 10).toString() : parseInt(cuil, 10).toString();
}